$(window).ready(function(){
    //mobile Button
    var mobileNavFlag = false;
    $('#header-menu-button, #dropdown-close').on('click', function(e){
        e.preventDefault();   
        
        if( mobileNavFlag == false){
            $(this).addClass('active-mobile-nav-button');
            $('#dropdown-nav').addClass('active-dropdown-nav');
            // $('#global-header').addClass('active-mobile-nav');

            mobileNavFlag = true;               
            e.stopPropagation();  
        } else {
            $(this).removeClass('active-mobile-nav-button');
            $('#dropdown-nav').removeClass('active-dropdown-nav');
            // $('#global-header').removeClass('active-mobile-nav');

            mobileNavFlag = false;              
            e.stopPropagation();                 
        }   
    });

    if( $('.homepage').length > 0 ){

    }

    function navBarPushdown(){
        // if( $('.homepage').length > 0 ){
            var navHeight = $('#announcementbar').outerHeight(false);
            $('#global-header').css('top', navHeight);
            $('body').css('padding-top', navHeight);
        // }
    }

    setTimeout(function(){
        navBarPushdown();
    }, 1000);

    $(window).resize(function(){
        navBarPushdown();
    });
});